import PDFUploader from '../components/PDFUploader';
import { useState } from 'react';
import { TrendingUp, Bell } from 'lucide-react';
import { motion } from 'framer-motion';

const UploadPage = () => {
  const [uploadResult, setUploadResult] = useState(null);

  const handleUploadSuccess = (result) => {
    setUploadResult(result);
  };

  return (
    <div className="space-y-6" data-testid="upload-page">
      {/* Header */}
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-[#191D1E]">
          Upload Newsletter
        </h1>
        <p className="text-[#687175] mt-1">
          Importez la newsletter quotidienne pour extraire les prix du marché
        </p>
      </div>

      {/* Instructions */}
      <div className="bg-white border border-[#BFC6CC]/12 rounded-2xl p-5 hover:shadow-md transition-shadow duration-200">
        <h3 className="text-lg font-bold text-[#191D1E] mb-4">Comment ça marche</h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 rounded-full bg-[#397DFF] flex items-center justify-center flex-shrink-0">
              <span className="text-white font-bold text-sm">1</span>
            </div>
            <div>
              <p className="font-medium text-[#191D1E]">Uploadez le PDF</p>
              <p className="text-sm text-[#687175]">Newsletter Place des Energies</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 rounded-full bg-[#397DFF] flex items-center justify-center flex-shrink-0">
              <span className="text-white font-bold text-sm">2</span>
            </div>
            <div>
              <p className="font-medium text-[#191D1E]">Extraction IA</p>
              <p className="text-sm text-[#687175]">Les prix sont extraits automatiquement</p>
            </div>
          </div>
          <div className="flex items-start gap-3">
            <div className="w-8 h-8 rounded-full bg-[#397DFF] flex items-center justify-center flex-shrink-0">
              <span className="text-white font-bold text-sm">3</span>
            </div>
            <div>
              <p className="font-medium text-[#191D1E]">Alertes vérifiées</p>
              <p className="text-sm text-[#687175]">Les clients sont notifiés si les seuils sont atteints</p>
            </div>
          </div>
        </div>
      </div>

      {/* Uploader */}
      <PDFUploader onUploadSuccess={handleUploadSuccess} />

      {/* Results Summary */}
      {uploadResult && uploadResult.data && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="space-y-4"
        >
          {/* Extracted Prices */}
          <div className="bg-white border border-[#BFC6CC]/12 rounded-2xl p-5 hover:shadow-md transition-shadow duration-200">
            <h3 className="text-lg font-bold text-[#191D1E] mb-4 flex items-center gap-2">
              <TrendingUp className="w-5 h-5 text-[#397DFF]" /> Prix extraits
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Electricity */}
              {uploadResult.data.electricity?.length > 0 && (
                <div>
                  <h4 className="text-sm font-medium text-[#F9C80E] mb-3">Électricité</h4>
                  <div className="space-y-2">
                    {uploadResult.data.electricity.map((price, idx) => (
                      <div key={idx} className="flex justify-between items-center p-2 bg-[#F5F6F9] rounded">
                        <span className="text-sm text-[#687175]">{price.contract_name}</span>
                        <span className="font-mono text-[#191D1E]">{price.price?.toFixed(2)} €</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {/* Gas */}
              {uploadResult.data.gas?.length > 0 && (
                <div>
                  <h4 className="text-sm font-medium text-[#397DFF] mb-3">Gaz Naturel</h4>
                  <div className="space-y-2">
                    {uploadResult.data.gas.map((price, idx) => (
                      <div key={idx} className="flex justify-between items-center p-2 bg-[#F5F6F9] rounded">
                        <span className="text-sm text-[#687175]">{price.contract_name}</span>
                        <span className="font-mono text-[#191D1E]">{price.price?.toFixed(2)} €</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Alerts Triggered Info */}
          {uploadResult.alerts_triggered > 0 && (
            <div className="bg-white border border-[#10D183]/30 rounded-xl p-5 shadow-sm">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#10D183]/10 flex items-center justify-center">
                  <Bell className="w-5 h-5 text-[#10D183]" />
                </div>
                <div>
                  <p className="font-bold text-[#191D1E]">
                    {uploadResult.alerts_triggered} alerte(s) déclenchée(s)
                  </p>
                  <p className="text-sm text-[#687175]">
                    Les clients concernés ont été notifiés par email
                  </p>
                </div>
              </div>
            </div>
          )}
        </motion.div>
      )}
    </div>
  );
};

export default UploadPage;
